import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { NodCommercialRoute } from "./nod-commercial.routes";

export function Commercial() {
  return (
    <Layout>
      {NodCommercialRoute.subRoutes && (
        <ModuleRouter subRoutes={NodCommercialRoute.subRoutes} path={NodCommercialRoute.path} />
      )}
    </Layout>
  );
}
